import script from "./UpcomingList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingList.vue?vue&type=script&setup=true&lang=ts"

import "./UpcomingList.vue?vue&type=style&index=0&id=2f38bd23&lang=css"

const __exports__ = script;

export default __exports__